<template>
  <transition name="fade">
    <div 
      v-if="showModal"
      class="download-mask" 
      @click="onMaskClick">
      <Space class="download-content">
        <a 
          class="download-btn"
          v-for="item in downloadList" 
          :key="item.image" 
          :href="item.url"
          target="__blank"
        >
          <XIcon :iconClass="item.image" style="font-size: 40px;"/>
          {{ item.title }}
        </a>
      </Space>
    </div>
  </transition>
</template>

<script>
// 腾讯云 CDN(file.yimutodo.com) 开启了 Referer 防盗链，仅放行 *.yimutodo.com 子域，
// 裸域(yimutodo.com)、localhost、微信内直接打开都会被 CDN 边缘节点直接返回 403。
// 因此桌面端安装包统一经由 cdn.yimutodo.com/dl.html 中转：中转页由七牛 CDN 提供
// (无防盗链限制)，再由它跳转到 file.yimutodo.com，此时 Referer 命中白名单即可下载。
// 修改安装包地址只需改 public/dl.html 里的 MAP，此处无需变动。
const DL_ENTRY = "https://cdn.yimutodo.com/dl.html?v=1&p=";

export default {
  data() {
    return {
      showModal: this.$store.state.showDownload,
      downloadList: [{
        title: 'Android',
        image: 'android',
        url: 'https://pgyer.com/PqTe',
      }, {
        title: 'iOS',
        image: 'apple',
        url: 'https://apps.apple.com/cn/app/id1672171155',
      }, {
        title: 'Windows arm64',
        image: 'windows',
        url: DL_ENTRY + 'win-arm64',
      }, {
        title: 'Windows x64',
        image: 'windows',
        url: DL_ENTRY + 'win-x64',
      }, {
        title: 'macOS arm64',
        image: 'apple',
        url: DL_ENTRY + 'mac-arm64',
      }, {
        title: 'macOS x64',
        image: 'apple',
        url: DL_ENTRY + 'mac-x64',
      }]
    }
  },
  methods: {
    onMaskClick() {
      this.$store.state.showDownload = false
    }
  },
  watch: {
    '$store.state.showDownload'(value) {
      this.showModal = value
    }
  }
}
</script>

<style lang="less" scoped>

  .download-mask {
    display: flex;
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    justify-content: center;
    z-index: 1999;
    .download-btn {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      // background-color: hsla(0,0%,100%,.07);
      background-color: #3D87DA75;
      color: hsla(0,0%,100%,.9);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 24px;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background-color: #3D87DAF0;
      }
    }
  }
</style>